@if (visible) {
  @if (items && items.length>1) {
    <pub-multi-select [items]="items" [label]="label" [multipleSelect]="multipleSelect"
      [allSelectedLabel]="allSelectedLabel"
      [cssClassName]="cssClassName" (selectValues)="onSelectValues($event)"
      [selectedValues]="selectedValues" [logger]="logger" data-testid="select"/>
  }
}
